import { z } from 'zod'
import { l } from '@manychat/manyui'

import { FilterDataType } from 'shared/api/requests/chat/filter/schemas'

import { MAX_CUSTOM_LABELS } from '../constants/labelsConstants'

const NAME_CHARACTER_LIMIT = 50

export const labelsFormSchema = z.object({
  emoji: z.string(),
  name: z
    .string()
    .min(1, { error: l.translate('Name is required') })
    .refine((val) => val.length <= NAME_CHARACTER_LIMIT, {
      message: l.translate('{count}/{limit} characters', {
        count: NAME_CHARACTER_LIMIT,
        limit: NAME_CHARACTER_LIMIT,
      }),
    }),
  filter: z
    .custom<FilterDataType>()
    .refine((val) => (val?.groups?.[0]?.items.length ?? 0) <= MAX_CUSTOM_LABELS, {
      message: l.translate(
        'Remove a condition to add a new one, {count} conditions is the limit.',
        {
          count: MAX_CUSTOM_LABELS,
        },
      ),
    })
    .nullable(),
})

export type LabelsFormValues = z.infer<typeof labelsFormSchema>

export enum LabelCondition {
  FILTER = 'filter_based',
  AI = 'ai_based',
}
